<template>
  <div class="ad-revenue-query">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      
      <el-form :model="form" label-position="top" class="query-form" @submit.native.prevent>
        <div class="query-form-row">
          <el-form-item label="时间范围" class="query-form-field">
            <el-date-picker
              v-model="form.date"
              type="date"
              placeholder="请选择日期"
              align="right"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="query-form-control"
              @change="handleAutoSearch"
            />
          </el-form-item>
          <el-form-item label="广告类型" class="query-form-field">
            <el-select
              v-model="form.adType"
              clearable
              placeholder="请选择广告类型"
              class="query-form-control"
              @change="handleAutoSearch"
            >
              <el-option label="激励" value="reward"></el-option>
              <el-option label="Banner" value="banner"></el-option>
              <el-option label="插屏" value="interstitial"></el-option>
              <el-option label="开屏" value="splash"></el-option>
              <el-option label="信息流" value="feed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名" class="query-form-field">
            <el-input
              v-model.trim="form.username"
              clearable
              placeholder="请输入用户名"
              class="query-form-control"
              @keyup.enter.native="handleAutoSearch"
              @clear="handleAutoSearch"
            />
          </el-form-item>
          <el-form-item class="query-form-actions">
            <div class="button-group">
              <el-button type="primary" :loading="loading" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button @click="handleReset" :disabled="loading" icon="el-icon-refresh">重置</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && !hasTable" description="暂无数据" />
      <div v-else>
        <div class="summary-bar">
          <el-row :gutter="20" class="summary-row">
            <el-col :xs="24" :sm="12">
              <el-card class="summary-card primary animate__animated animate__bounceInLeft">
                <div class="summary-content">
                  <i class="el-icon-wallet summary-icon"></i>
                  <div class="summary-value">{{ totalEcpmDisplay }}</div>
                  <div class="summary-label">总收入</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-card class="summary-card success animate__animated animate__bounceInRight">
                <div class="summary-content">
                  <i class="el-icon-document summary-icon"></i>
                  <div class="summary-value">{{ totalCount }}</div>
                  <div class="summary-label">总条数</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        
        
        <div class="table-scroll-wrapper">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在查询..."
          class="animate__animated animate__fadeIn"
        >
          <el-table-column prop="username" label="用户名" min-width="120" />
          <el-table-column prop="adnName" label="广告平台" min-width="120" />
          <el-table-column prop="adType" label="广告类型" min-width="100" :formatter="adTypeFormatter" />
          <el-table-column prop="ecpm" label="eCPM" min-width="100" :formatter="ecpmFormatter" />
          <el-table-column
            prop="createdTime"
            label="创建时间"
            min-width="170"
            :formatter="timeFormatter"
          />
        </el-table>
        </div>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            background
            :layout="paginationLayout"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { request } from '@/utils/http.js'
import responsiveMixin from '@/mixins/responsive'

const AD_TYPE_MAP = {
  reward: '激励',
  banner: 'Banner',
  interstitial: '插屏',
  splash: '开屏',
  feed: '信息流',
}

export default {
  name: 'AdRevenueQuery',
  mixins: [responsiveMixin],
  data() {
    return {
      form: {
        date: '',
        username: '',
        adType: ''
      },
      loading: false,
      error: '',
      response: null,
      tableData: [],
      // 分页参数
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 添加后端返回的总计数据
      totalCount: 0,
      totalEcpm: 0
    }
  },
  computed: {
    hasTable() {
      return Array.isArray(this.tableData) && this.tableData.length > 0
    },
    totalEcpmDisplay() {
      return (this.totalEcpm / 1000).toFixed(2)
    },
  },
  methods: {
    pad2(n) {
      return n.toString().padStart(2, '0')
    },
    getTodayDate() {
      const now = new Date()
      const y = now.getFullYear()
      const m = this.pad2(now.getMonth() + 1)
      const d = this.pad2(now.getDate())
      return `${y}-${m}-${d}`
    },
    getDayStartEnd(dateStr) {
      if (!dateStr) return { start: '', end: '' }
      const day = dateStr.slice(0, 10)
      return { start: `${day} 00:00:00`, end: `${day} 23:59:59` }
    },
    pretty(obj) {
      try {
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return String(obj)
      }
    },
    timeFormatter(row, column, cellValue) {
      if (!cellValue) return ''
      return String(cellValue).replace('T', ' ')
    },
    adTypeFormatter(row, column, cellValue) {
      if (!cellValue) return ''
      return AD_TYPE_MAP[cellValue] || cellValue
    },
    ecpmFormatter(row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return ''
      return (Number(cellValue) / 1000).toFixed(2)
    },
    handleAutoSearch() {
      this.pagination.pageNum = 1
      this.handleSearch()
    },
    handleReset() {
      this.form.date = this.getTodayDate()
      this.form.username = ''
      this.form.adType = ''
      this.tableData = []
      this.response = null
      this.error = ''
      // 重置分页参数
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
      // 重置总计数据
      this.totalCount = 0
      this.totalEcpm = 0
      // 清空图表
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.fetchData(false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1; // 重置到第一页
      this.fetchData();
    },
    async handleSearch() {
      // 搜索时重置到第一页
      this.pagination.pageNum = 1;
      // 搜索时清空现有数据
      this.tableData = []
      // 重置总计数据
      this.totalCount = 0
      this.totalEcpm = 0
      await this.fetchData()
    },
    async fetchData() {
      this.error = ''
      this.response = null

      const { start, end } = this.getDayStartEnd(this.form.date)
      if (!start || !end) {
        this.error = '请选择日期'
        return
      }

      // 构建URL参数
      let url = `/admin/ADRevenueDataAdmin/getADRevenueDataByDateRange?startDate=${encodeURIComponent(start)}&endDate=${encodeURIComponent(end)}&pageNum=${this.pagination.pageNum}&pageSize=${this.pagination.pageSize}`;
      
      // 如果有广告类型筛选，则添加到URL参数中
      if (this.form.adType) {
        url += `&adType=${encodeURIComponent(this.form.adType)}`;
      }
      
      // 如果有用户名，则添加到URL参数中
      if (this.form.username) {
        url += `&username=${encodeURIComponent(this.form.username)}`;
      }

      this.loading = true
      try {
        const result = await request(url, {
          method: 'GET'
        })
        
        // 处理返回的数据
        if (result && typeof result === 'object' && result.data) {
          const data = result.data
          const newRecords = Array.isArray(data.records) ? data.records : []
          
          // 设置表格数据
          this.tableData = newRecords
          
          // 更新分页信息
          this.pagination.total = data.total || 0
          this.pagination.pageSize = data.size || this.pagination.pageSize
          this.pagination.pageNum = data.current || this.pagination.pageNum
          
          // 使用后端返回的总计数据
          this.totalCount = data.total_count || 0
          this.totalEcpm = data.total_ecpm || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
          this.pagination.pageNum = 1
          // 重置总计数据
          this.totalCount = 0
          this.totalEcpm = 0
        }
      } catch (e) {
        this.error = e && e.message ? e.message : '请求出现错误'
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.form.date = this.getTodayDate()
  },
  mounted() {
    // 页面加载完成后自动执行一次搜索
    this.handleSearch();
  },
}
</script>

<style scoped>
.ad-revenue-query {
  padding: 0;
}

.query-form {
  margin-bottom: 16px;
}

.query-form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
}

.query-form-field {
  flex: 1 1 220px;
  min-width: 200px;
  margin-bottom: 0;
}

.query-form >>> .el-form-item__label {
  line-height: 1.4;
  padding-bottom: 6px;
  color: #606266;
  font-weight: 500;
}

.query-form-actions {
  flex: 0 0 auto;
  margin-bottom: 0;
  margin-left: auto;
  align-self: flex-end;
}

.query-form-actions >>> .el-form-item__label {
  display: none;
}

.query-form >>> .el-form-item__content {
  width: 100%;
}

.query-form-control,
.query-form >>> .el-date-editor.el-input {
  width: 100%;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.button-group .el-button {
  margin-left: 0;
}

@media (max-width: 768px) {
  .query-form-field {
    flex: 1 1 100%;
  }

  .query-form-actions {
    flex: 1 1 100%;
    margin-left: 0;
    align-self: stretch;
  }

  .button-group {
    width: 100%;
    justify-content: stretch;
  }

  .button-group .el-button {
    flex: 1;
  }

  .summary-bar .el-col {
    margin-bottom: 12px;
  }

  .summary-card {
    height: auto;
    min-height: 100px;
  }
}

.summary-card {
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  height: 120px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}

.summary-card.primary {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  color: #1976d2;
  border: none;
}

.summary-card.success {
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  color: #388e3c;
  border: none;
}

.summary-content {
  text-align: center;
  /* padding: 18px; */
}

.summary-icon {
  font-size: 24px;
  margin-bottom: 8px;
  display: block;
  color: inherit;
}

.summary-value {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 4px;
}

.summary-label {
  font-size: 13px;
  opacity: 0.8;
  font-weight: normal;
}

.summary-bar {
  margin-bottom: 30px;
}

.error {
  color: #c0392b;
  background: #fdecea;
  border: 1px solid #f5c6cb;
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

/* Speed up animations */
.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}
</style>